<template>
  <div
    class="main-background filter-page-container"
    :style="{ height: pageHeight + 'px' }"
  >
    <button type="button"
      class="filter-page-back-button"
      @click="$emit('setIsChangePage', 'home')"
    >
      <!-- <chevron-left-icon class="back-button-icon" /> -->
      <p class="back-button-text">Кошик</p>
    </button>
    <!-- Порожній кошик -->
    <div v-if="cartLoading" class="cart-empty-state" role="status">Завантажуємо кошик…</div>
    <div v-else-if="cartError" class="cart-empty-state" role="alert">
      <p class="cart-empty-text">{{ cartError }}</p>
      <button type="button" class="cart-empty-cta" @click="retryCart">Спробувати ще раз</button>
    </div>
    <div v-else-if="isCartEmpty" class="cart-empty-state" role="status">
      <svg
        class="cart-empty-illustration"
        width="140"
        height="140"
        viewBox="0 0 140 140"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <circle cx="70" cy="70" r="70" fill="#E8F7F9" />
        <path
          d="M38 46h8l6 44h44l8-30H52"
          stroke="#16ABB8"
          stroke-width="4"
          stroke-linecap="round"
          stroke-linejoin="round"
          fill="none"
        />
        <circle cx="58" cy="100" r="6" fill="#16ABB8" />
        <circle cx="92" cy="100" r="6" fill="#16ABB8" />
        <path
          d="M70 36v-8M84 40l5-6M56 40l-5-6"
          stroke="#9FE0E7"
          stroke-width="4"
          stroke-linecap="round"
        />
      </svg>
      <p class="cart-empty-title">Ваш кошик поки порожній</p>
      <p class="cart-empty-text">
        Додайте товари з каталогу, щоб оформити замовлення
      </p>
      <button
        class="cart-empty-cta"
        @click="$emit('setIsChangePage', 'home')"
      >
        Перейти до каталогу
      </button>
    </div>

    <div
      v-else
      class="cart-page-container-list"
      :style="{ height: listHeight + 'px' }"
    >
      <div v-for="item of cartElements.items" :key="item.product_id || item.product_name">
        <div v-if="!item.no_product" :class="['cart-page-item', { 'cart-item-deficit': Number(item.qty_item) > Number(item.qty_product) }]">
          <img
            :src="item.img"
            alt=""
            class="cart-page-item-image"
            @click="onOpenProduct(item)"
          />
          <div class="cart-page-item-info">
            <button
              @click="deleteProduct(item)"
              class="delete-product-cart-button"
              :disabled="cartUpdating"
              :aria-label="`Видалити з кошика: ${item.product_name}`"
            >
              <x-icon class="delete-button-icon" aria-hidden="true" />
            </button>
            <button type="button" class="cart-page-item-name" @click="onOpenProduct(item)">
              {{ item.product_name }}
            </button>
            <p class="cart-page-item-code">Код: {{ item.product_id }}</p>
            <p class="cart-page-item-price">{{ item.mod_price | money }} / шт.</p>
            <p class="cart-line-total">Сума: {{ Number(item.mod_price) * Number(item.qty_item) | money }}</p>
            <p v-if="Number(item.qty_item) > Number(item.qty_product)" class="cart-deficit-warning">
              На складі лише {{ item.qty_product }} шт.!
            </p>
            <div class="product-counter-container">
              <button
                :disabled="cartUpdating || Number(item.qty_item) <= 1"
                :aria-label="`Зменшити кількість: ${item.product_name}`"
                class="product-counter-button"
                @click="setChangeCounter('-', item)"
              >
                <minus-icon class="product-counter-button-icon" />
              </button>
              <input
                type="text"
                class="product-counter-input"
                @keyup.enter="handleEnterKey"
                :value="item.qty_item"
                :disabled="cartUpdating"
                :aria-label="`Кількість: ${item.product_name}`"
                inputmode="numeric"
                @change="setQuantity(item, $event)"
                :max="item.qty_product"
              />
              <button
                :disabled="cartUpdating || Number(item.qty_item) >= Number(item.qty_product)"
                :aria-label="`Збільшити кількість: ${item.product_name}`"
                class="product-counter-button"
                @click="setChangeCounter('+', item)"
              >
                <plus-icon class="product-counter-button-icon" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="cartUndo" class="cart-undo" role="status">
      <span>Видалено: {{ cartUndo.item.product_name }}</span>
      <button type="button" :disabled="cartUpdating" @click="undoRemoval">Повернути</button>
    </div>
    <p v-if="$store.getters.undoMessage" class="cart-undo" role="status">{{ $store.getters.undoMessage }}</p>
    <div v-if="actionError" class="cart-action-error" role="alert">
      <p>{{ actionError }}</p>
      <button type="button" class="return-to-shop" @click="retryCart">Оновити кошик</button>
    </div>
    <div v-if="!cartLoading && !cartError && !isCartEmpty" class="bottom-filter-button-container">
      <div class="final-price-container">
        <p class="final-price">Усього</p>
        <p class="final-price">
          {{ ((cartElements && cartElements.sumTotal) || 0) | money }}
        </p>
      </div>
      <button
        v-if="cartElements && cartElements.items && cartElements.items.length"
        class="filtration-button"
        @click="goToMakeOrderPage"
        :disabled="hasDeficitProducts || cartUpdating"
      >
        Оформити замовлення
      </button>
      <button class="return-to-shop" @click="$emit('setIsChangePage', 'home')">
        Повернутися до покупок
      </button>
    </div>
  </div>
</template>

<script>
import { PlusIcon, MinusIcon, XIcon } from "vue-feather-icons";
import { mapMutations } from "vuex";

export default {
  name: "cart-page",
  components: {
    PlusIcon,
    MinusIcon,
    XIcon,
  },
  props: {
    addedToCardProducts: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      pageHeight: 0,
      listHeight: 0,
      actionError: "",
      undoTimer: null,
    };
  },
  async mounted() {
    console.log('Cart page opened');
    this.pageHeight = window.innerHeight - 150;
    this.listHeight = window.innerHeight - 50 - 175;
    window.scrollTo(0, 0);
    document.body.addEventListener("click", (event) => {
      let target = event.target;
      target;
    });
  },
  beforeDestroy() { clearTimeout(this.undoTimer); },
  methods: {
    async undoRemoval() {
      this.actionError = '';
      try { await this.$store.dispatch('undoCartRemoval'); }
      catch (error) { this.actionError = error.message === 'Товар зараз недоступний.' ? error.message : 'Не вдалося підтвердити повернення. Перевірте кошик перед новим додаванням.'; }
    },
    ...mapMutations(["addPerPage"]),
    retryCart() {
      this.actionError = "";
      return this.$store.dispatch("getCartProducts", window.location.pathname.split("/").filter(Boolean)[0]);
    },
    handleEnterKey() {
      const activeElement = document.activeElement;
      if (activeElement.tagName === "INPUT") {
        activeElement.blur();
      }
    },
    onOpenProduct(item) {
      this.$store.commit("setIsOpenProductInfo", { id: item.product_id });
      this.$store.dispatch("getOneProduct", item.product_id);
      this.addPerPage("cart");
      this.$emit("setIsChangePage", "productInfo");
    },
    validateInput(item) {
      item.qty_item = item.qty_item.replace(/\D/g, "");

      const numericValue = parseInt(item.qty_item);
      if (numericValue > item.qty_product) {
        item.qty_item = item.qty_product.toString();
      }
    },
    goToMakeOrderPage() {
      if (this.cartElements?.items?.length) {
        this.$emit("setIsChangePage", "makeOrder");
      }
    },
    async runCartAction(action, data) {
      if (this.cartUpdating) return;
      this.actionError = "";
      try {
        await this.$store.dispatch(action, JSON.stringify(data));
      } catch (error) {
        await this.$store.dispatch("getCart");
        this.actionError = "Не вдалося підтвердити зміну. Перевірте кошик перед повторною дією.";
      }
    },
    setQuantity(item, event) {
      const quantity = Number(event.target.value);
      event.target.value = item.qty_item;
      if (!Number.isInteger(quantity) || quantity < 1 || quantity > Number(item.qty_product)) {
        this.actionError = `Вкажіть кількість від 1 до ${item.qty_product}.`;
        return;
      }
      return this.runCartAction("setCartQuantity", { product_id: item.product_id, order_id: this.getOrderId.id, quantity });
    },
    setChangeCounter(value, product) {
      let data = {
        product_id: product.product_id,
        order_id: this.getOrderId.id,
      };
      if (value === "+") {
        return this.runCartAction("getOneMoreProduct", data);
      } else {
        return this.runCartAction("getMinusProduct", data);
      }
    },
    deleteProduct(product) {
      let data = {
        product_id: product.product_id,
        order_id: this.getOrderId.id,
      };
      return this.runCartAction("deleteProductFromCart", data);
    },
  },
  computed: {
    cartUndo() { return this.$store.getters.cartUndo; },
    cartUpdating() { return this.$store.getters.cartUpdating; },
    cartLoading() { return this.$store.getters.cartLoading; },
    cartError() { return this.$store.getters.cartError; },
    cartElements() {
      return this.$store.getters.getCustomerCart || { items: [] };
    },
    getOrderId() {
      return this.$store.getters.getOrderId;
    },
    getOrders() {
      return this.$store.getters.getOrders;
    },
    hasDeficitProducts() {
      return (this.cartElements.items || []).some(item => Number(item.qty_item) > Number(item.qty_product));
    },
    isCartEmpty() {
      const items = this.cartElements && this.cartElements.items;
      if (!items || !items.length) return true;
      return items.every((i) => i.no_product);
    },
  },
  watch: {
    cartUndo: { immediate: true, handler(value) {
      clearTimeout(this.undoTimer);
      if (value) this.undoTimer = setTimeout(() => this.$store.commit('setCartUndo', null), Math.max(0, value.expiresAt - Date.now()));
    } },
  },
};
</script>

<style scoped>
.cart-line-total { font: 600 14px/20px Inter, sans-serif; margin: 4px 0 12px; color: #333; }
.cart-undo { padding: 12px 16px; display: flex; align-items: center; gap: 12px; flex-wrap: wrap; background: #e8f7f9; font: 14px/20px Inter, sans-serif; }
.cart-undo button { min-height: 44px; padding: 8px 16px; background: #fff; border: 1px solid #075a63; color: #075a63; border-radius: 8px; cursor: pointer; }
.main-background {
  background: #fff;
}
.filter-page-back-button {
  position: relative;
  border-bottom: 1px solid #f0f0f0;
  padding: 18px;
  cursor: pointer;
}

.back-button-icon {
  position: absolute;
}

.back-button-text {
  text-align: center;
}

.filter-page-container {
  display: flex;
  flex-direction: column;
}
.bottom-filter-button-container {
  background: transparent;
  box-shadow: 0px -4px 4px 0px rgba(0, 0, 0, 0.04);
  padding: 16px;
  margin-top: auto;
}

.filtration-button {
  padding: 12px;
  width: 100%;
  border-radius: 8px;
  background: #16abb8;
  color: #fff;
  text-align: center;
  font-family: Inter;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  border: none;
  cursor: pointer;
  margin-bottom: 10px;
}
.return-to-shop {
  padding: 12px;
  width: 100%;
  border-radius: 8px;
  background: #fff;
  color: #16abb8;
  text-align: center;
  font-family: Inter;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  border: none;
  cursor: pointer;
  margin-bottom: 10px;
  border: 1px solid #16abb8;
}
.cart-empty-state {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 40px 24px;
  gap: 8px;
}
.cart-empty-illustration {
  margin-bottom: 12px;
}
.cart-empty-title {
  color: #333;
  font-family: Inter;
  font-size: 20px;
  font-weight: 700;
  line-height: 26px;
}
.cart-empty-text {
  color: #707070;
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  max-width: 260px;
  margin-bottom: 12px;
}
.cart-empty-cta {
  padding: 14px 28px;
  border-radius: 8px;
  background: #16abb8;
  color: #fff;
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  border: none;
  cursor: pointer;
  transition: background 0.2s ease;
}
.cart-empty-cta:hover {
  background: #14a0ad;
}
.cart-page-container-list {
  display: flex;
  flex-direction: column;
  margin-top: 18px;
  height: 100%;
  overflow-y: scroll;
}
.cart-page-item {
  position: relative;
  display: flex;
  gap: 24px;
  padding: 6px 16px 16px 16px;
  border-bottom: 1px solid #f0f0f0;
}
.product-counter-container {
  display: flex;
  gap: 4px;
  margin-left: auto;
}
.product-counter-button {
  border: 1px solid #c4c4c4;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  cursor: pointer;
}
.product-counter-button-icon {
  width: 8px;
  height: 8px;
}
.product-counter-input {
  width: 40px;
  height: 24px;
  border-radius: 4px;
  background: #f0f0f0;
  border: none;
  text-align: center;
  outline-offset: 0;
  outline: 0;
  color: #707070;
  text-align: center;
  font-family: "Lato", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
}
.cart-page-item-image {
  border-radius: 12px;
  border: 1px solid #d2d6db;
  width: 140px;
  height: 140px;
  cursor: pointer;
}
.cart-page-item-name {
  color: #333;
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  padding-right: 15px;
  cursor: pointer;
}
.cart-page-item-code {
  color: #707070;
  font-family: "Lato", sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  margin-top: 14px;
}
.cart-page-item-price {
  color: #16abb8;
  font-family: "Lato", sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  margin-top: 19px;
  margin-bottom: 7px;
}
.final-price-container {
  display: flex;
  justify-content: space-between;
}
.final-price {
  color: #121212;
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  margin-bottom: 5px;
}

.delete-product-cart-button {
  position: absolute;
  top: 5px;
  right: 5px;
  background-color: transparent;
  border: none;
  cursor: pointer;
}
.delete-button-icon {
  color: #686868;
}
.cart-item-deficit {
  border: 2px solid #ff5252;
  background: #fff0f0;
}
.cart-deficit-warning {
  color: #ff5252;
  font-size: 14px;
  font-weight: 500;
  margin: 4px 0 0 0;
}

/* === Значні покращення для великих екранів (1024px+) === */
@media (min-width: 1024px) {
  .main-background {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0;
  }

  .filter-page-back-button {
    max-width: 1400px;
    margin: 0 auto;
    padding: 24px 40px;
    border-bottom: 1px solid #f0f0f0;
  }

  .back-button-text {
    font-size: 20px;
    font-weight: 600;
  }

  .cart-page-container-list {
    max-width: 1000px;
    margin: 40px auto 0 auto;
    padding: 0 40px;
  }

  .cart-page-item {
    padding: 24px;
    gap: 32px;
    border-radius: 16px;
    margin-bottom: 16px;
    transition: all 0.3s ease;
  }

  .cart-page-item:hover {
    background: #fafafa;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  }

  .cart-page-item-image {
    width: 200px;
    height: 200px;
    border-radius: 16px;
    transition: transform 0.3s ease;
  }

  .cart-page-item:hover .cart-page-item-image {
    transform: scale(1.05);
  }

  .cart-page-item-name {
    font-size: 18px;
    line-height: 24px;
    padding-right: 20px;
  }

  .cart-page-item-code {
    font-size: 16px;
    margin-top: 12px;
  }

  .cart-page-item-price {
    font-size: 22px;
    margin-top: 16px;
    margin-bottom: 12px;
  }

  .product-counter-container {
    margin-top: 12px;
  }

  .product-counter-button {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    transition: all 0.2s ease;
  }

  .product-counter-button:hover:not(:disabled) {
    background: #e0e0e0;
    transform: scale(1.1);
  }

  .product-counter-input {
    width: 50px;
    height: 32px;
    font-size: 16px;
  }

  .delete-product-cart-button {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    transition: all 0.2s ease;
  }

  .delete-product-cart-button:hover {
    background: #fff5f5;
    transform: scale(1.1);
  }

  .bottom-filter-button-container {
    width: 700px;
    margin: 0 auto;
    padding: 20px;
    border-radius: 20px 20px 0 0;
    box-shadow: 0 -8px 24px rgba(0, 0, 0, 0.1);
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 20px;
    row-gap: 16px;
    align-items: center;
  }

  .final-price-container {
    margin-bottom: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    grid-column: 1 / -1;
  }

  .final-price {
    font-size: 24px;
    font-weight: 700;
  }

  .filtration-button,
  .return-to-shop {
    max-width: none;
    width: 100%;
    margin: 0;
    font-size: 16px;
    font-weight: 700;
    padding: 15px;
    border-radius: 14px;
    transition: all 0.3s ease;
  }

  .filtration-button:hover {
    background: #14a0ad;
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(22, 171, 184, 0.4);
  }

  .return-to-shop:hover {
    background: #f0f9ff;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(22, 171, 184, 0.2);
  }

  .cart-item-deficit {
    border-radius: 16px;
  }
}
</style>

<style scoped>
.cart-page-item-info { flex: 1; min-width: 0; }
.cart-page-item-name { background: transparent; border: 0; text-align: left; width: 100%; padding-right: 40px; min-height: 44px; }
.product-counter-button { width: 44px; height: 44px; flex-shrink: 0; }
.product-counter-button-icon { width: 16px; height: 16px; }
.product-counter-input { width: 40px; height: 44px; }
.delete-product-cart-button { width: 44px; height: 44px; }
.cart-action-error { padding: 12px 16px; color: #a42020; font-size: 14px; }
@media (max-width: 360px) {
  .cart-page-item { gap: 12px; }
  .cart-page-item-image { width: 96px; height: 96px; object-fit: contain; }
}
</style>

<style scoped>
.filter-page-back-button { width: 100%; background: #fff; border: 0; border-bottom: 1px solid #f0f0f0; cursor: pointer; color: #333; }
</style>

<style scoped>
.cart-page-item-price { color: #075a63; }
</style>
